import PropTypes from 'prop-types'
import { useEffect, useRef, useState } from 'react'
import EventEmitter, {
  RECALCULATE_SIZE_TRACKER,
  SCROLL_DOWN,
  SCROLL_TO_TOP,
} from '../../helpers/EventEmitter'
import { Element } from '../html/element'
import { Icon } from '../html/icon'
import classes from './index.module.scss'

export const Collapse = ({
  children,
  iconStyle,
  title,
  style,
  isOpen,
  onToggle,
  renderLeft,
  renderRight,
  isToggleIconOnly,
  scrollIdToCollapse,
}) => {
  const ref = useRef()
  const [isCollapse, setIsCollapse] = useState(isOpen)

  useEffect(() => {
    EventEmitter.dispatch(RECALCULATE_SIZE_TRACKER, 'sideBar')
  }, [isCollapse])

  useEffect(() => {
    const handleScrollDown = (id) => {
      if (id === scrollIdToCollapse) {
        setIsCollapse(false)
      }
    }
    EventEmitter.subscribe(SCROLL_DOWN, handleScrollDown)

    return () => {
      EventEmitter.unsubscribe(SCROLL_DOWN, handleScrollDown)
    }
  }, [])

  useEffect(() => {
    const handleScrollToTop = (id) => {
      if (id === scrollIdToCollapse) {
        setIsCollapse(true)
      }
    }
    EventEmitter.subscribe(SCROLL_TO_TOP, handleScrollToTop)

    return () => {
      EventEmitter.unsubscribe(SCROLL_TO_TOP, handleScrollToTop)
    }
  }, [])

  const onTogglePanel = () => {
    onToggle(!isCollapse)
    setIsCollapse(!isCollapse)
  }

  const renderCollapseIcon = () => {
    return (
      <Element
        elementName="span"
        style={{ fontSize: 10, ...iconStyle, lineHeight: 0 }}
      >
        <Icon
          onClick={isToggleIconOnly ? onTogglePanel : () => {}}
          className={`${isCollapse ? 'icon-arrow-top' : 'icon-arrow-bottom'}`}
        />
      </Element>
    )
  }

  return (
    <>
      <Element
        ref={ref}
        className={classes.collapseButton}
        style={{ color: '#3A414B', backgroundColor: '#F3F3F3', ...style }}
        onClick={isToggleIconOnly ? () => {} : onTogglePanel}
      >
        <div className={classes.collapseButtonContent}>
          {renderLeft ? renderLeft(isCollapse) : <span>{title}</span>}
          {renderRight ? (
            <div className={classes.right}>
              {renderRight(isCollapse)}
              {renderCollapseIcon()}
            </div>
          ) : (
            renderCollapseIcon()
          )}
        </div>
      </Element>
      {isCollapse && (
        <Element
          className={classes.collapseContent}
          style={{ backgroundColor: '#FFFFFF' }}
        >
          {children}
        </Element>
      )}
    </>
  )
}

Collapse.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string,
  isOpen: PropTypes.bool,
  onToggle: PropTypes.func,
  renderLeft: PropTypes.func,
  renderRight: PropTypes.func,
  isToggleIconOnly: PropTypes.bool,
}

Collapse.defaultProps = {
  onToggle: () => {},
  isOpen: false,
}
